import { BASE_URL } from '../const';
import { mogamboRequestV2 } from './utils';

export async function getPartnerResponsesAsync(nodeId, currentLanguage) {
  const url =
    `${BASE_URL}node/api_responses/${nodeId}` +
    `?lang_src=${currentLanguage.languageSource}&lang_script=${currentLanguage.languageScript}`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
}

export async function sendPartnerResponsesAsync(nodeId, data, domainTitle) {
  const url = `${BASE_URL}node/api_responses/${nodeId}`;
  const headers =  {
    'x-haptik-bot-name': domainTitle,
  };
  const response = mogamboRequestV2(url, 'POST', data, true, headers);
  return Promise.resolve(response);
}
